<template>
    <div class="mt-5">
        <h3>{{ $t('filter.filterListPreview') }}</h3>
        <div class="table-sm table-kb" v-if="dataPreviews.data">
            <table class="table custom-table table-hover table-common">
                <thead>
                    <tr class="header-text">
                        <th v-for="(item, index) in dataPreviews.fields" scope="col" :key="'th' + index">
                            {{ item.label }}
                        </th>
                    </tr>
                </thead>
                <tbody v-if="dataPreviews.data && dataPreviews.data.length > 0">
                    <tr class="row-kintone" v-for="(itemData, index) in dataPreviews.data" :key="'preview' + index">
                        <td v-for="(item, index) in dataPreviews.fields" scope="row" :key="'td' + index" :data-title="item.label">
                            <div class="content-record" v-if="item.type !== TYPE_SUB_TABLE">
                                <div v-if="item.type === TYPE_RICK_TEXT" v-html="mapDataItem(itemData[item.code], item)"></div>
                                <div v-else-if="item.type === 'NUMBER' || item.type === 'CALC'" class="text-right">
                                    {{ mapDataItem(itemData[item.code], item) }}
                                </div>
                                <div v-else>{{ mapDataItem(itemData[item.code], item) }}</div>
                            </div>

                            <div class="content-record" v-else>[Data Table]</div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td class="bg-white" :colspan="dataPreviews.fields ? Object.keys(dataPreviews.fields).length : 0">
                            <el-empty :description="$t('member.msgNoDataSearch')"></el-empty>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { TYPE_SUB_TABLE, TYPE_RICK_TEXT } from '@/config/constants.js';
import { formatDateTime, isIsoDate } from '@/utils';
export default {
    name: 'list-preview',
    props: {
        dataPreviews: { required: true }
    },
    data() {
        return {
            TYPE_SUB_TABLE,
            TYPE_RICK_TEXT
        };
    },
    computed: {},
    watch: {},
    methods: {
        mapDataItem(dataGet, itemField) {
            let data = dataGet.value;
            if (typeof data === 'object') {
                if (data != null && data.length < 1) {
                    return '';
                }
                if (data) {
                    let dataReturn = '';
                    for (let element of data) {
                        if (typeof element === 'string') {
                            dataReturn = dataReturn + ' ' + element;
                        }
                    }
                    return dataReturn;
                }
                return data;
            }
            if (isIsoDate(data)) {
                return formatDateTime(new Date(data), 'YYYY/MM/DD HH:mm:ss');
            }
            if (itemField.unit && itemField?.unitPosition == 'AFTER' && data) {
                return data + ' ' + itemField.unit;
            }
            if (itemField.unit && itemField?.unitPosition == 'BEFORE' && data) {
                return itemField.unit + ' ' + data;
            }
            return data;
        }
    }
};
</script>
